export interface DemoStep {
  key: string;
  label: string;
  blurb: string;
}

// The Forrester demo is a single route with these client-side steps. In the
// two-stage demo the team runs the full Newton framework LIVE in Newton, then
// picks up here: step 1 RECEIVES the Newton handoff, and steps 2–3 run the
// streaming plan + buy. (The old separate Newton-replay and channel-plan steps
// are collapsed into the single handoff recap.)
export const DEMO_STEPS: DemoStep[] = [
  {
    key: 'newton-handoff',
    label: '1 · Bliss Point Handoff',
    blurb:
      'What Bliss Point Audience & Planner handed us: the selected hypothesis, the Cognitive-Performance audience, the ' +
      'Get/To/By comms strategy, and the Balanced investment scenario. Accept it to continue into ' +
      'streaming planning.'
  },
  {
    key: 'media-plan',
    label: '2 · Media Plan',
    blurb:
      'The TVAD planning agent runs a Bliss Point Audience & Planner–primed intake and produces a line-item streaming plan.'
  },
  {
    key: 'buy',
    label: '3 · Direct-IO & Nexxen Buy',
    blurb:
      'Direct lines are drafted to the Agent Order Approvals screen; a human approves — nothing sends automatically.'
  }
];
